import {IRouletteBet} from "./IRouletteBet";

export class DozenBet implements IRouletteBet {
    constructor(public index: number, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/DozenBet.ts